/* STATS */
export const GET_STATS = "GET_STATS"
export const GET_STATS_SUCCESS = "GET_STATS_SUCCESS"
export const GET_STATS_FAIL = "GET_STATS_FAIL"
